import React, { useEffect, useRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ListItemText from '@mui/material/ListItemText';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { Chip, IconButton } from "@mui/material";
import { Notifications, Settings, SettingsOutlined, CloseOutlined, West, East, SettingsInputComponent } from "@mui/icons-material";
import { TextField, InputAdornment, Input } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import listViewImage from '../../assets/images/list_view.png'; // Import the List View image
import calendarViewImage from '../../assets/images/calendar_view.png'; // Import the Calendar View image
import UserNotification from './UserNotification/userNotification';
import { PushPin, PushPinOutlined } from '@mui/icons-material';
import Joyride from 'react-joyride';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {
  userGuideSteps,
  joyrideStyles,
  joyrideLocale,
  steps
} from './userGuideConfig';

import {
    Button,
    DialogActions,
    FormControl,
    FormControlLabel,
    FormGroup,
    InputLabel,
    MenuItem,
    OutlinedInput,
    RadioGroup,
    Select,
    Switch,
    Tab,
    Tabs,
    Tooltip,
    styled,
} from "@mui/material";
import { ExpandMore, InfoOutlined } from '@mui/icons-material';
import Checkbox from '@mui/material/Checkbox';
import timezones from 'timezones-list';
import { toast } from 'react-toastify';

import './UserPreference.css';
import { getParentServices, getNotificationData, updateUserPreferences } from '../../Services';
import { useNavigate } from 'react-router-dom'
import moment from 'moment-timezone';
import Loader from '../Common/Loader/Loader';
import { vendorDict, eventTypes, SwitchToggle, customTheme, getGroupingOfSources } from '../../utility';
import { ClearIcon } from '@mui/x-date-pickers';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ padding: '16px 20px', marginLeft: '280px' }}>{children}</Box>
            )}
        </div>
    );

}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
};

const IntegrationHeavyComponent = React.memo(({ 
    serviceEntity, 
    selectedService, 
    setSelectedServices, 
    handleSources,
    run
  }) => {
    //get grouped sources list
    const sourceGroupsArray = getGroupingOfSources(Object.keys(serviceEntity));
    const flattenedSourceList = sourceGroupsArray.flatMap(obj => obj.sources.map(e => e.source));
    const rowsPerPageOptions = [10, 15, 20];
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
    const [pinSelectedOnTop, setPinSelectedOnTop] = useState(false);
    const data = [...new Set(Object.values(serviceEntity).flat())].sort((a, b) => {
        if (!pinSelectedOnTop) return a.localeCompare(b);

        const aSelected = Object.values(selectedService).some(list => list.includes(a));
        const bSelected = Object.values(selectedService).some(list => list.includes(b));
        if (aSelected && !bSelected) return -1;
        if (!aSelected && bSelected) return 1;
        return a.localeCompare(b);
        });

    const [searchKey, setSearchKey] = useState("");
    const filteredData = data.filter(row =>
        row.toLowerCase().includes(searchKey.toLowerCase())
    );
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);
    const paginatedData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
    const [selectedSource, setSelectedSource] = useState({});
    
    const getPageNumbers = () => {
        const pages = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (currentPage <= 3) {
                pages.push(1, 2, 3, "...", totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
            }
        }
        return pages;
    };
    useEffect(() => {
        getPageNumbers(); // Reset pagination when search changes
    }, [searchKey]);

    useEffect(() => {
        if (run) {
            setCurrentPage(1);
        }
    }, [run]);

    useEffect(() => {
        if (run && currentPage === 1) {
            const wrapperEl = document.querySelector(".table-wrapper");
            const scrollEl = document.querySelector(".table-container");

            if (scrollEl) {
                scrollEl.scrollTop = 0;
                scrollEl.scrollLeft = 0;
            }

            const dialogContentEl = document.querySelector(".MuiDialogContent-root");
            if (dialogContentEl) {
                dialogContentEl.scrollTop = 0;
            }

            const checkboxEl = document.getElementById("integration-checkbox");
            const checkboxMarker = document.getElementById("joyride-checkbox-marker");

            if (checkboxEl && checkboxMarker && wrapperEl && scrollEl) {
                const rect = checkboxEl.getBoundingClientRect();
                const wrapperRect = wrapperEl.getBoundingClientRect();
                checkboxMarker.style.top = `${rect.top - wrapperRect.top + scrollEl.scrollTop}px`;
                checkboxMarker.style.left = `${rect.left - wrapperRect.left}px`;
                checkboxMarker.style.width = `${rect.width}px`;
                checkboxMarker.style.height = `${rect.height}px`;

            }

            const rowEl = document.getElementById("service-name-row");
            const rowMarker = document.getElementById("joyride-row-marker");

            if (rowEl && rowMarker && wrapperEl && scrollEl) {
                const rect = rowEl.getBoundingClientRect();
                const wrapperRect = wrapperEl.getBoundingClientRect();

                rowMarker.style.top = `${rect.top - wrapperRect.top + scrollEl.scrollTop}px`;
                rowMarker.style.left = `${rect.left - wrapperRect.left}px`;
                rowMarker.style.width = `${rect.width}px`;
                rowMarker.style.height = `${rect.height}px`;

            }
        }
        }, [run, currentPage, filteredData.length]);


    //Select All Services
    const handleSourceCheckboxChange = (source, checked) => {
        // Get vendor key for this source
        const vendorKey = vendorDict[source];

        // Get all services under this source
        const servicesInSource = serviceEntity[source] || [];

        setSelectedServices((prevSelected) => {
            let updatedServices;

            if (checked) {
            // Add all services from this source
            // Merge existing selected with servicesInSource without duplicates
            const existing = prevSelected[vendorKey] || [];
            updatedServices = Array.from(new Set([...existing, ...servicesInSource]));
            } else {
            // Remove all services from this source
            const existing = prevSelected[vendorKey] || [];
            updatedServices = existing.filter(service => !servicesInSource.includes(service));
            }

            return {
            ...prevSelected,
            [vendorKey]: updatedServices,
            };
        });
    };


    return <div className='mb-1'>
        <div className='d-flex align-items-start justify-content-between mb-2'>
            <div>
                <p className='m-0 font-900'>Preferred Business Services</p>
                <div className='d-flex align-items-center'>
                    <strong className='text-s text-secondary fw-bold'>Enable the integrations for preferred business services in the app.</strong>
                    <Tooltip className='ml-1' title={'User will be able to view the releases, maintenances and outages related to selected business Service. Any dependent services will be automatically included based on the configuration in the Service Registry.'}>
                        <InfoOutlined sx={{ fontSize: 16 }} />
                    </Tooltip>
                </div>
            </div>
            <div className="min-w-200 mt-1" id="integration-search">
                <TextField
                    size="small"
                    variant="standard"
                    placeholder="Search for Business Service"
                    value={searchKey}
                    onChange={(e) => {
                        setSearchKey(e.target.value);
                        setCurrentPage(1);
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon sx={{ color: "#888", fontSize: "1.2rem" }} />
                            </InputAdornment>
                        ),
                        disableUnderline: false, // Use Material-UI's underline
                    }}
                    fullWidth
                    sx={{
                        input: { fontSize: '13px' },
                    }}
                />
            </div>
        </div>
        <div className="table-wrapper" style={{ position: "relative" }}>
            <div id="joyride-checkbox-marker" style={{position: "absolute", pointerEvents: "none", zIndex: 20}} />
            <div id="joyride-row-marker" style={{ position: "absolute", pointerEvents: "none", zIndex: 20 }} />

            <div className="table-container">
                {serviceEntity && Object.keys(serviceEntity).length > 0 ? (
                    <table className="manage-sources-table text-center text-sm">
                        <thead>
                            <tr>
                                <th
                                className="min-w-200 py-2 px-2 position-sticky border-0 text-s"
                                style={{
                                    zIndex: 5,
                                    fontWeight: 800,
                                    whiteSpace: 'nowrap',
                                    backgroundColor: "#F2F2F2",
                                    outline: "1px solid #dee2e6",
                                    filter: "drop-shadow(0px -6px 3px rgba(0, 0, 0, 0.4))",
                                }}
                                >
                                    <Box
                                        onClick={() => {
                                        setPinSelectedOnTop(prev => !prev);
                                        setCurrentPage(1);
                                        }}
                                        sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignItems: 'center',
                                        gap: '6px',
                                        cursor: 'pointer',
                                        userSelect: 'none',
                                        color: 'grey.600',
                                        fontWeight: 'normal',
                                        '&:hover span, &:hover a': {
                                            textDecoration: 'underline',
                                        },
                                        }}
                                    >
                                        <span className='text-secondary font-weight-normal'>
                                        {pinSelectedOnTop ? "Unpin Selected" : "Pin Selected"}
                                        </span>


                                        {pinSelectedOnTop ? (
                                        <PushPinOutlined sx={{ fontSize: 18 }} />
                                        ) : (
                                        <PushPin sx={{ fontSize: 18 }} />
                                        )}
                                    </Box>
                                </th>
                                {sourceGroupsArray.map((source) => (
                                    <th
                                        className='py-2 px-3 position-sticky border border-top-0 text-s'
                                        style={{ fontWeight: 800, whiteSpace: 'nowrap', backgroundColor: "#F2F2F2" }}
                                        key={source["group"]}
                                        colSpan={source["sources"].length}
                                    >
                                        {source["group"]}
                                    </th>
                                ))}
                            </tr>
                            <tr>
                                <th className='py-2 pr-3 position-sticky border-0 text-s'
                                    style={{
                                        zIndex: 4,
                                        fontWeight: 800,
                                        whiteSpace: 'nowrap',
                                        backgroundColor: "#F2F2F2",
                                        outline: "1px solid #dee2e6",
                                        filter: "drop-shadow(0px -3px 3px rgba(0, 0, 0, 0.4))",
                                        paddingLeft: '8px'
                                    }}>
                                <span>Business Service</span>

                            </th>
                            {flattenedSourceList.map((source) => (
                                <th
                                    className='py-2 px-2 position-sticky border text-s no-left-padding'
                                    style={{ fontWeight: 800, whiteSpace: 'nowrap', backgroundColor: "#F2F2F2" }}
                                    key={`sourceList-${source}`}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'flex-start', gap: '4px' }}>
                                        <Checkbox
                                            size="small"
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 18,  marginTop: '0.5px' }, padding: 0, marginLeft: 0  }}
                                            onChange={(e) => handleSourceCheckboxChange(source, e.target.checked)}
                                            checked={
                                            serviceEntity[source]?.length > 0 &&
                                            serviceEntity[source].every(service =>
                                                selectedService[vendorDict[source]]?.includes(service)
                                            )
                                            }
                                            indeterminate={
                                                serviceEntity[source]?.some(service =>
                                                selectedService[vendorDict[source]]?.includes(service)
                                                ) &&
                                                !serviceEntity[source]?.every(service =>
                                                selectedService[vendorDict[source]]?.includes(service)
                                                )
                                            }
                                            
                                        />
                                        <span style={{ verticalAlign: 'middle', paddingTop: '0px', paddingBottom: '0px',  display: 'flex', alignItems: 'center', marginLeft: 0, }}>{source}</span>
                                    </div>
                                </th>
                            ))}                            

                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData && paginatedData.length > 0 ? (paginatedData.map((serviceName) => (
                                <tr key={serviceName}>
                                    <td  className="position-sticky px-2 p-1 bg-white border-0 text-s text-secondary"
                                    id={serviceName === paginatedData[1] ? 'service-name-row' : undefined}
                                        style={{
                                            minWidth: "220px",
                                            fontWeight: 800,
                                            outline: "1px solid #dee2e6",
                                            borderBottom: "1px solid #dee2e6 !important",
                                            zIndex: 4,
                                            filter: "drop-shadow(0px 4px 3px rgba(0, 0, 0, 0.2))"
                                        }}>

                                        <a className='text-primary font-weight-normal' target='_blank' href={`https://one.autodesk.com/apps/service-registry/service-components?name=${serviceName}`}>{serviceName}</a>
                                    </td>
                                    {flattenedSourceList.map((source) => (
                                        <td className="p-1 border" key={`${serviceName}-${source}`}>
                                            {serviceEntity[source]?.includes(serviceName) ? (
                                                <div className="table-cell-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingLeft: '4px' }}>
                                                    <Checkbox
                                                    id={serviceName === '360Insights' && source === 'AWS Health' ? 'integration-checkbox' : undefined}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }}
                                                        checked={selectedService[vendorDict[source]]?.includes(serviceName) || false} // Check if selected
                                                        onChange={() => handleSources(serviceName, vendorDict[source])} // Toggle selection
                                                    />
                                                </div>
                                            ) : (
                                                <div></div>
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            )))
                                : (
                                    <tr>
                                        <td colSpan={7}>
                                            <div className='py-3 px-4'>No records to show.</div>
                                        </td>
                                    </tr>
                                )}
                        </tbody>
                    </table>
                ) : (
                    <div>No data available</div>
                )}
            </div>
        </div>
        <div className="d-flex align-items-center mt-1 select-border-0">
            <span className='text-s'>Rows per page:</span>
            <FormControl size='small'>
                <Select
                    labelId="page"
                    id="page"
                    value={rowsPerPage}
                    onChange={(e) => {
                        setRowsPerPage(Number(e.target.value));
                        setCurrentPage(1);
                    }}
                    sx={{ border: "none", outline: "none", boxShadow: "none" }}
                >
                    {rowsPerPageOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                            <ListItemText primary={option} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <div className="flex gap-2">
                <IconButton
                    className="mx-2 bg-gray-100 disabled:opacity-50"
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                >
                    <West sx={{ fontSize: 16 }} />
                </IconButton>
                {getPageNumbers().map((page, index) => (
                    typeof page === "number" ? (
                        <Button
                            key={index}
                            className='mx-1 px-2 text-2'
                            variant={page === currentPage ? "contained" : "text"}
                            onClick={() => page !== "..." && setCurrentPage(page)}
                            disabled={page === "..."}
                            sx={{ height: '32px', minWidth: '30px' }}
                        >
                            {page}
                        </Button>
                    ) : (
                        <span key={index} className="px-2 text-gray-500 text-s">{page}</span>
                    )
                ))}
                <IconButton
                    className="mx-2 bg-gray-100 disabled:opacity-50"
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages || !paginatedData.length}
                >
                    <East sx={{ fontSize: 16 }} />
                </IconButton>
            </div>
        </div>
    </div>;
});

const UserPreference = ({ open, onClose, preferences, isNewUser, openTab }) => {
    const navigate = useNavigate();
    const localtz = moment.tz.guess()
    const [value, setValue] = React.useState(0);
    const [services, setServices] = useState([]);
    const [filterServices, setFilterServices] = useState([]);
    const [searchService, setSearchServices] = useState('');
    const searchInputRef = useRef(null);
    const [preferenceList, setPreferenceList] = useState(preferences);
    // const [Notifications, setNotification] = useState();
    const [selectedService, setSelectedServices] = useState({});
    const [serviceEntity, setServiceEntity] = useState();
    const [filteredServiceEntityData, setFilterServiceEntity] = useState();
    const [selectedTimeZone, setSelectedTimeZone] = useState('');
    const [expanded, setExpanded] = React.useState('panel1');
    const loggedIn = sessionStorage.getItem("isLoggedIn") === 'true' ? true : false;
    const isPilotUser = sessionStorage.getItem("isPilotUser") === 'true' ? true : false;
    const [isSubmit, setSubmit] = useState(false);
    const [isLoading, setLoader] = useState(false);
    const [notificationData, setNotificationData] = useState([]);
    const [platformData, setPlatformData] = useState(preferences['platform']);
    const [isInstanceMenu, setIsInstanceMenu] = useState(false);

    const [stepIndex, setStepIndex] = useState(0);
    const [run, setRun] = useState(false);


    const handleJoyrideCallback = (data) => {
    const { status, type, index, action } = data;
    const finished = ['finished', 'skipped'];


    if (finished.includes(status) || action === 'close' || type === 'tour:end') {
        setRun(false);
        setStepIndex(0);
        return;
    }

    if (type === 'step:before' && index === 1) {
        setValue(1);
    }

    if (type === 'step:after') {
        if (action === 'next') {
        setStepIndex((prev) => prev + 1);
        } else if (action === 'prev') {
        setStepIndex((prev) => Math.max(prev - 1, 0));
        }
    }
    };

    useEffect(() => {
    if (open && isNewUser) {
        setTimeout(() => {
        setRun(true);
        setStepIndex(0);
        }, 300); 
    }
    }, [open, isNewUser]);


    const handleAccordChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const options = {
        position: "top-right",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        autoClose: 2000,
        progress: undefined,
        theme: "light",
    };

    useEffect(() => {
        if (preferences) {
            init();
        }
    }, [preferences]);

    useEffect(() => {
        if (localtz) {
            setSelectedTimeZone(localtz);
        }
    }, []);

    useEffect(() => {
        if (open && loggedIn) {
            setLoader(true);
            getParentServicesList();
            getNotificationDetails(preferences["id"]);
        }
    }, [open])

    useEffect(() => {
        if (Object.keys(selectedService).length) {
            setServices(createAllServiceList());
        }
    }, [selectedService])

    useEffect(() => {
        if (searchService) {
            const filteredData = services.filter(row =>
                row.toLowerCase().includes(searchService.toLowerCase())
            );
            setFilterServices(filteredData);
        } else setFilterServices(services);
    }, [searchService, services]);

    const init = () => {
        setValue(0);
        if (isNewUser) {
            setValue(0);
        } else if (openTab) {
            setValue(openTab);
        }
        setPreferenceList(preferences);
        // customTheme = preferences['theme'];
    };

    
    const getNotificationDetails = async (id) => {
        try {
            const response = await getNotificationData(id);
            if (response && response.data) {
                setNotificationData(response.data.notifications);
                console.log(notificationData);
            }
        } catch (error) {
            console.log(error);
            if (
                error?.response?.status === 401 ||
                error?.response?.data?.message === "User authorization failed."
            ) {
                onClose();
                navigate("/logout");
            } else {
                toast.error("Error while fetching subscription details, Try reloading!", options);
            }
        }
        setLoader(false);
    };

    const getParentServicesList = async () => {
        try {
            const response = await getParentServices();
            if (response && response.data) {
                const serv = response.data;
                Object.keys(serv).forEach(vendor => {
                    serv[vendor].sort((a, b) => a.localeCompare(b));
                });
                setServiceEntity(serv);
                setFilterServiceEntity(serv);
                handleServiceSelection(serv);
            }
        } catch (error) {
            console.log(error);
            if (
                error?.response?.status === 401 ||
                error?.response?.data?.message === "User authorization failed."
            ) {
                onClose();
                navigate("/logout");
            } else {
                toast.error("Error while fetching service details, Try reloading!", options);
            }
        }
    };

    const handleServiceSelection = (serv) => {
        Object.values(vendorDict).map(releaseType => {
            if (releaseType in preferences && preferences[releaseType] !== null) {
                handleServiceChange(preferences[releaseType].length > 0 ? preferences[releaseType] : [], releaseType)
            }
        })
    }
    
    const applyDefaultIntegrations = (serv) => {
        Object.keys(vendorDict).forEach((vendor) => {
            const sourceKey = vendorDict[vendor];
            const availableServices = serv[vendor] || [];
            const defaultList = ['Salesforce', 'Tibco', 'Apigee', 'Heroku'].filter(str =>
                availableServices.includes(str)
            );
            if (defaultList.length > 0) {
                handleServiceChange(defaultList, sourceKey);
            } else {
                handleServiceChange([], sourceKey);
            }
        });
    };

    const createAllServiceList = () => {
        let list = [];
        Object.keys(vendorDict).map(vendor => {
            if (vendorDict[vendor] in selectedService) {
                list = [...list, ...selectedService[vendorDict[vendor]]];
            }
        })
        const quickFilter = preferenceList["quick_services"].filter((serv) => {
            return list.includes(serv);
        });
        setPreferenceList((prevSelectedValues) => ({
            ...prevSelectedValues,
            'quick_services': quickFilter,
        }));
        return Array.from(new Set(list)).sort();
    }

    const handleChange = (event, newValue) => {
        setIsInstanceMenu(false);
        setValue(newValue);
    };

    const handleThemeChange = (event) => {
        setPreferenceList((prevSelectedValues) => ({
            ...prevSelectedValues,
            'theme': event.target.checked ? 'dark' : 'light',
        }));
        customTheme = event.target.checked ? 'dark' : 'light';
    }

    const handleLongReleaseChange = (event) => {
        setPreferenceList((prevSelectedValues) => ({
            ...prevSelectedValues,
            'show_long_release': !event.target.checked,
        }));
    };

    const handleReleaseChange = (event) => {
        setPreferenceList((prevSelectedValues) => ({
            ...prevSelectedValues,
            'long_release': event.target.value,
        }));
    }

    const handleSources = (serviceName, source) => {
        setSelectedServices((prevSelected) => {

            // Toggle the service in the selectedServices array
            const updatedServices = prevSelected[source]?.includes(serviceName)
                ? prevSelected[source].filter((service) => service !== serviceName) // Remove if exists
                : [...(prevSelected[source] || []), serviceName]; // Add if not exists

            const updatedState = { ...prevSelected, [source]: updatedServices };
            return updatedState;
        });
    };

    const handleServiceChange = (value, key) => {
        setSelectedServices((prevSelectedValues) => ({
            ...prevSelectedValues,
            [key]: value,
        }));
    }

    const handleQuickFiltersChange = (event) => {
        // User should only select maximum of 5 to 6 quick filters
        if (event.target.value.length <= 5) {
            const {
                target: { value },
            } = event;
            setPreferenceList((prevSelectedValues) => ({
                ...prevSelectedValues,
                'quick_services': value,
            }));
        } else {
            options['hideProgressBar'] = true;
            options['autoClose'] = 3000;
            toast.info("You can only select upto 5 quick filters!", options);
        }
    };

    const handleTimeZoneChange = (event) => {
        setSelectedTimeZone(event.target.value);
    };

    const handleViewChange = (event) => {
        setPreferenceList((prevSelectedValues) => ({
            ...prevSelectedValues,
            'view': event.target.value,
        }));
    }

    const cancelChanges = (event, reason) => {
        if (reason && reason === "backdropClick") return;
        onClose();
        getParentServicesList();
        init();
    };

    const saveChanges = () => {
        setPreferenceList((prevSelectedValues) => ({
            ...prevSelectedValues,
            'saas': selectedService['saas'] || "",
            '365': selectedService['365'] || "",
            'efr': selectedService['efr'] || "",
            'bcr': selectedService['bcr'] || "",
            'bfr': selectedService['bfr'] || "",
            'emr': selectedService['emr'] || "",
            'odr': selectedService['odr'] || "",
            'rfc': selectedService['rfc'] || "",
            'dbpswd': selectedService['dbpswd'] || "",
            'fwexc': selectedService['fwexc'] || "",
            'awshealth':selectedService['awshealth'] || "",
            'vc':selectedService['vc'] || "",
            'rma':selectedService['rma'] || ""
        }));
                if (platformData !== preferences['platform']) {
            setPreferenceList((prevSelectedValues) => ({
                ...prevSelectedValues,
                'platform': platformData
            }));
        }
        if (hasEmptyArray) {
            toast.warning("Please select at least one service in Manage Sources!", options);
        } else {
            setSubmit(true);
        }
    };

    const hasEmptyArray = !(Object.values(selectedService).some(value => Array.isArray(value) && value.length > 0));

    useEffect(() => {
        if (isSubmit) {
            submitChanges();
        }
    }, [isSubmit]);

    const submitChanges = async () => {
        setLoader(true);
        try {
            const [resp1] = await Promise.allSettled([updateUserPreferences(
                preferenceList
            )]);
            if (resp1.value.status === 200) {
                toast.success(
                    "Settings updated successfully!",
                    options
                );
                sessionStorage.setItem(
                    "preference",
                    JSON.stringify(preferenceList)
                );
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                toast.error("Error while updating Settings!", options);
                setLoader(false);
            }

        } catch (error) {
            console.log(error);
            setLoader(false);
            if (
                error?.response?.status === 401 ||
                error?.response?.data?.message === "User authorization failed."
            ) {
                onClose();
                navigate("/logout");
            } else {
                toast.error("Error while updating settings!", options);
            }
        }
    };

    const handleRemoveQuickFilter = (event, value) => {
        event.stopPropagation();
        setPreferenceList((prev) => ({
            ...prev,
            quick_services: prev.quick_services.filter((item) => item !== value),
        }));
    };


    return preferenceList && (
        
        isLoading ?
            <Loader /> :
            <Dialog
            className='preference'
            open={open}
            onClose={cancelChanges}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: {
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                margin: 0,
                borderRadius: 0,
                alignSelf: 'end',
                
                }
            }}
            >
                <DialogTitle
                    sx={{
                        padding: '0', // Remove extra padding
                        display: 'flex', // Flexbox for alignment
                        alignItems: 'center', // Center content vertically
                        borderBottom: '1px solid #ccc', // Add bottom border
                    }}
                >
                    {/* Vertical Line */}
                  <Box
                    sx={{
                      width: '280px',
                      height: '100%',
                      borderRight: '1px solid #ccc',
                      borderColor: 'divider',
                      backgroundColor: '#F1F0F0',
                      padding: '10px 20px',
                      fontWeight: '900',
                      position: 'relative',
                    }}
                    className="text-body-1"
                  >
                    Settings
                    <Tooltip title="Start the tour" arrow>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setStepIndex(0);
                          setTimeout(() => {
                            setRun(true);
                          }, 500);
                        }}
                        sx={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          padding: '4px',
                          color: '#555',
                        }}
                      >
                        <HelpOutlineIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>


                    {value !== 2 && <>
                        <Box
                            sx={{
                                padding: '10px 20px',
                                fontWeight: '900'
                            }}
                            className='text-body-1'
                        >
                            {(() => {
                                switch (value) {
                                    case 0:
                                        return "General"
                                    case 1:
                                        return "Integrations"
                                    case 2:
                                        return "Notifications"
                                    default:
                                        return null
                                }
                            })()}
                        </Box>
                    </>}
                </DialogTitle>
                <DialogContent sx={{ paddingLeft: '0', overflow: run ? 'hidden' : 'auto', }}>
                    <Box sx={{ flexGrow: 1, display: 'flex', height: '100%,' }} >
                        <Tabs
                            orientation='vertical'
                            variant="scrollable"
                            value={value}
                            onChange={handleChange}
                            aria-label="Vertical tabs example"
                            sx={{ borderRight: 1, borderColor: 'divider', position: 'fixed', height: '100%', backgroundColor: '#F1F0F0', width: '280px', paddingTop: '6px', zIndex: 100 }}
                            TabIndicatorProps={{
                                sx: {
                                    left: 0,
                                    width: "4px"
                                }
                            }}
                        >
                            <Tab
                                icon={<Settings sx={{ fontSize: 19 }} />}
                                iconPosition="start"
                                label="General"
                                sx={{
                                    justifyContent: 'flex-start',
                                    textTransform: 'none',
                                    minHeight: '32px',
                                    backgroundColor: value === 0 ? 'white' : 'transparent', // Highlight selected tab
                                }}
                                {...a11yProps(0)}
                            />

                            <Tab
                                icon={<SettingsInputComponent sx={{ fontSize: 19 }} />}
                                iconPosition="start"
                                label="Integrations"
                                sx={{
                                    justifyContent: 'flex-start',
                                    textTransform: 'none',
                                    minHeight: '32px',
                                    backgroundColor: value === 1 ? 'white' : 'transparent', // Highlight selected tab
                                }}
                                data-tour-id="integrations-tab"
                                {...a11yProps(1)}
                            />
                            <Tab
                                icon={<Notifications sx={{ fontSize: 19 }} />}
                                iconPosition="start"
                                label="Notifications"
                                sx={{
                                    justifyContent: 'flex-start',
                                    textTransform: 'none',
                                    minHeight: '32px',
                                    backgroundColor: value === 2 ? 'white' : 'transparent', // Highlight selected tab
                                }}
                                {...a11yProps(2)}
                            />

                        </Tabs>

                        <TabPanel value={value} index={0} >
                            {/* <div>
                                <h6><strong>Default Theme</strong></h6>
                                <FormControlLabel
                                    className='pl-3'
                                    control={<MaterialUISwitch sx={{ m: 1 }}
                                        checked={preferenceList.theme !== 'light'}
                                        onChange={handleThemeChange} />}
                                    label={preferenceList.theme === 'light' ? 'Light Theme' : 'Dark Theme'}
                                />
                            </div> */}
                            {
                                value == 0 && (
                                    <>
                                        <div className="d-flex align-items-start justify-content-between border-bottom pb-3" style={{ width: 780 }}>
                                            <div>
                                                <p className='m-0 font-900'>Preferred View</p>
                                                <strong className='text-secondary text-sm'>Please select your prefered view in the app.</strong>
                                            </div>
                                            <div>
                                                <RadioGroup
                                                    row
                                                    className="pl-4 "
                                                    aria-labelledby="view"
                                                    name="view"
                                                    value={preferenceList.view}
                                                    onChange={handleViewChange}
                                                    sx={{
                                                        ml: 2,
                                                        gap: "20px", // Add space between the two divs
                                                    }}
                                                    style={{
                                                        display: "flex", // Ensure flexbox layout
                                                        justifyContent: "center", // Center content
                                                        gap: "20px", // Add horizontal space between divs
                                                    }}
                                                >
                                                    {/* Calendar View */}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            border: preferenceList.view === "calendar" ? "2px solid black" : "2px solid lightgrey",
                                                            borderRadius: "8px",
                                                            padding: "5px",
                                                            width: "160px",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => handleViewChange({ target: { value: "calendar" } })}
                                                    >
                                                        <img
                                                            src={calendarViewImage}
                                                            alt="Calendar View"
                                                            style={{ width: "138px", height: "70px", marginBottom: "6px" }}
                                                        />
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                justifyContent: "space-between", // Ensures text is on the left and radio button is on the right
                                                                width: "100%", // Ensures the div spans full width
                                                                padding: "0 2px 0 5px"
                                                            }}
                                                        >
                                                            {/* Label Text */}
                                                            <span>Calendar View</span>

                                                            {/* Radio Button */}
                                                            <Radio
                                                                value="calendar"
                                                                checked={preferenceList.view === "calendar"}
                                                                onChange={handleViewChange}
                                                                sx={{
                                                                    padding: "0 !important", // Forces padding to be 0
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* List View */}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            border: preferenceList.view === "list" ? "2px solid black" : "2px solid lightgrey   ",
                                                            borderRadius: "8px",
                                                            padding: "5px",
                                                            width: "160px",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => handleViewChange({ target: { value: "aws" } })}
                                                    >
                                                        <img
                                                            src={listViewImage}
                                                            alt="List View"
                                                            style={{ width: "138px", height: "70px", marginBottom: "6px" }}
                                                        />
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                justifyContent: "space-between", // Ensures text is on the left and radio button is on the right
                                                                width: "100%", // Ensures the div spans full width
                                                                padding: "0 2px 0 5px"
                                                            }}
                                                        >
                                                            {/* Label Text */}
                                                            <span>AWS Alerts View</span>

                                                            {/* Radio Button */}
                                                            <Radio
                                                                value="aws"
                                                                checked={preferenceList.view === "aws"}
                                                                onChange={handleViewChange}
                                                                sx={{
                                                                    padding: "0 !important", // Forces padding to be 0
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </RadioGroup>
                                            </div>
                                        </div>
                                        <div className='pt-4 pb-3 border-bottom' style={{ width: 780 }}>
                                            <p className='m-0 font-900'>Quick Filters</p>
                                            <strong className='text-secondary text-sm'>Select quick filters from your preferred business services. (Limit upto 5)</strong>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '2px' }} >
                                                <FormControl size='small'>
                                                    <Select
                                                        labelId="quick-filters"
                                                        id="quick-filters"
                                                        multiple
                                                        value={preferenceList['quick_services']}
                                                        onChange={handleQuickFiltersChange}
                                                        onClose={() => setSearchServices("")}
                                                        input={<OutlinedInput sx={{ minHeight: '43px'}} />}
                                                        renderValue={(selected) => (
                                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                {selected.map((value) => (
                                                                    <Chip label={value} key={value}
                                                                        style={{ borderRadius: '4px', height: "26px", background: 'E6E6E4' }}
                                                                        onMouseDown={(event) => event.stopPropagation()}
                                                                        onDelete={(event) => handleRemoveQuickFilter(event, value)}
                                                                        deleteIcon={<CloseOutlined />}
                                                                        className="custom-chip"
                                                                    />
                                                                ))}
                                                            </Box>
                                                        )}
                                                        fullWidth
                                                        MenuProps={{ disablePortal: true, autoFocus: false }}
                                                    >
                                                        <div className="d-flex flex-column mt-1 bg-white position-sticky bottom-0 pb-2 px-3">
                                                            <div className="d-flex align-items-center position-relative">
                                                                <Input
                                                                    inputRef={searchInputRef}
                                                                    value={searchService}
                                                                    onChange={(e) => {
                                                                        setSearchServices(e.target.value);
                                                                    }}
                                                                    onKeyDown={(e) => e.stopPropagation()}
                                                                    sx={{ fontSize: "0.9rem", lineHeight: "1.5", width: "100%", paddingRight: '30px' }}
                                                                    placeholder="Search"
                                                                />
                                                                {searchService && (
                                                                    <IconButton
                                                                        onClick={() => setSearchServices("")}
                                                                        sx={{
                                                                            position: "absolute",
                                                                            right: "10px",
                                                                            cursor: "pointer",
                                                                            padding: 0,
                                                                            pb: "6px",
                                                                        }}
                                                                        aria-label="clear"
                                                                        size="small"
                                                                    >
                                                                        <ClearIcon />
                                                                    </IconButton>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {filterServices.map((option) => (
                                                            <MenuItem key={option} value={option}>
                                                                <Checkbox checked={preferenceList['quick_services'] && preferenceList['quick_services'].indexOf(option) > -1} />
                                                                <ListItemText primary={option} />
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </div>
                                        <div className='pt-4 pb-2 border-bottom'>
                                            <div>
                                                <p className='m-0 font-900'>Events Configuration</p>
                                            </div>
                                            <div className='toggle-label'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='ml-3 pt-2'>
                                                        <div className="d-flex align-items-center mb-1">
                                                            <strong className='text-sm fw-bold'>Hide long running events in app.</strong>
                                                            <Tooltip className='ml-2' title={'Show/Hide the long releases from the view which are running for more than ' + preferenceList["long_release"] + '.'}>
                                                                <InfoOutlined fontSize='small' />
                                                            </Tooltip>
                                                        </div>
                                                        <FormControlLabel control={
                                                            <SwitchToggle
                                                                checked={!preferenceList["show_long_release"]}
                                                                onChange={handleLongReleaseChange}
                                                            />
                                                        }
                                                        />
                                                    </div>
                                                </div>
                                                {
                                                    !preferenceList["show_long_release"] && (
                                                        <div className='border-top mt-2 ml-3'>
                                                            <p className='my-2'>Releases running for more than selected duration won't be visible in the app.</p>
                                                            <FormControl className='mb-3' size='small' sx={{ width: '770px' }}>
                                                                <Select
                                                                    labelId="duration"
                                                                    id="duration"
                                                                    value={preferenceList["long_release"]}
                                                                    onChange={handleReleaseChange}
                                                                    input={<OutlinedInput sx={{ height: '43px', width: '770px' }} />}
                                                                    fullWidth
                                                                    MenuProps={{ disablePortal: true, autoFocus: false }}
                                                                >
                                                                    {['1 week', '2 weeks', '4 weeks'].map((name) => (
                                                                        <MenuItem key={name} value={name}>
                                                                            <ListItemText primary={name} />
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </div>
                                                    )}
                                            </div>
                                        </div>
                                    </>
                                )}
                        </TabPanel>
                        <TabPanel value={value} index={1} style={{ width: '100%' }} >
                            {
                                value == 1 && (
                                    <IntegrationHeavyComponent
                                    serviceEntity={serviceEntity}
                                    selectedService={selectedService}
                                    setSelectedServices={setSelectedServices}
                                    handleSources={handleSources}
                                    run={run}
                                    />
                                )
                            }              
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <UserNotification
                                serviceEntity={serviceEntity}
                                notificationData={notificationData}
                                platformData={platformData}
                                setPlatformData={setPlatformData}
                                id={preferences["id"]}
                                setIsInstanceMenu = {setIsInstanceMenu}

                            />
                        </TabPanel>
                    </Box>
                </DialogContent>
                <DialogActions className="py-3 pr-4 pl-2" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ width: '275px', zIndex: 1100 }}>
                        <a
                        className="d-flex align-items-center text-primary"
                        target="_blank"
                        rel="noreferrer"
                        href="https://wiki.autodesk.com/x/nx0XZ"
                        style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
                        >
                        <InfoOutlined sx={{ fontSize: 19, marginRight: 1 }} />
                        <span>About EAUC</span>
                        </a>
                    </Box>
                    <Box sx={{ flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                        {value === 1 && (
                            <Tooltip
                                title="Default Services: Salesforce, Tibco, Apigee, Heroku"
                                componentsProps={{
                                    tooltip: {
                                    sx: {
                                        whiteSpace: 'nowrap',
                                    },
                                    },
                                }}
                                >
                                <Button
                                variant="outlined"
                                onClick={() => applyDefaultIntegrations(serviceEntity)}
                                sx={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    marginLeft: 1,
                                }}
                                >
                                Default Integrations
                                </Button>
                            </Tooltip>
                        )}
                        </Box>
                        <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'center',
                            flexWrap: 'nowrap',
                        }}
                        >
                        {!isNewUser && (
                            <Button
                            onClick={cancelChanges}
                            variant="outlined"
                            sx={{ minHeight: '36px' }}
                            >
                            Cancel
                            </Button>
                        )}
                        {!isInstanceMenu && (
                            <Button 
                            data-tour-id="save-button"
                            onClick={saveChanges}
                            variant="contained"
                            disabled={hasEmptyArray}
                            sx={{ minHeight: '36px' }}
                            >
                            Save
                            </Button>
                        )}
                        </Box>
                    </Box>
                </DialogActions>
                {run && (
                <Joyride
                    run={run}
                    steps={steps}
                    stepIndex={stepIndex}
                    continuous
                    showSkipButton
                    disableOverlayClose
                    spotlightPadding={4}
                    scrollToFirstStep={false}
                    disableScrolling={true}
                    locale={joyrideLocale(stepIndex)}
                    styles={joyrideStyles}
                    callback={handleJoyrideCallback}
                />
                )}
            </Dialog>
    );
};

export default UserPreference;